<template>
  <div style="padding: 0 20px">
    <online-form ref="onlineForm"
                 @onSuccess="handleSuccess"
                 :formSchema="setFormSchema()"
                 :uiSchema="uiSchema"
                 :single="true"
                 :tree="false">
      <template v-for="item in Object.keys($scopedSlots)" :slot="item">
        <slot :name="item"></slot>
      </template>
    </online-form>
  </div>
</template>

<script>
import OnlineForm from '@/components/online/autoform/OnlineFormSwitch'
import FormItem from '@views/onlineModal/formItemConfig'

export default {
  name: 'ModalForm',
  components: { OnlineForm },
  provide() {
    return {
      langFieldData: () => []
    }
  },
  props: {
    detailData: {
      type: Object
    }
  },
  data() {
    return {
      sh: {},
      model: {},
      uiSchema: {
        itemattrs: '',
        method: 'post',
        // 表单是几列布局
        formTemplate: '1',
        url: ''
      }
    }
  },
  methods: {
    addForm(data) {
      this.$refs.onlineForm.add(data)
    },
    editForm(data) {
      this.$refs.onlineForm.edit(data)
    },
    // 根据JS增强中传入的key获取表单项配置
    setFormSchema() {
      return FormItem[ this.detailData.formItemKey ] || {}
    },
    // 获取表单数据
    getFormData() {
      let { data, form } = this.$refs.onlineForm.getMainFormData()
      return {
        formData: data,
        form
      }
    },
    handleSuccess() {

    }
  }
}
</script>